import {useMutation} from '@apollo/react-hooks';

import type {
    LeadCardFieldsUpdate as LeadCardFieldsUpdateMutation,
    LeadCardFieldsUpdateVariables as LeadCardFieldsUpdateMutationVariables,
    LeadCardFieldsUpdateInput,
} from 'nutshell-graphql-types';

import LEAD_CARD_FIELDS_UPDATE from '../mutations/update-lead-card-fields.graphql';
import GET_LEAD_CARD_FIELDS from '../queries/get-lead-card-fields.graphql';

export function useUpdateLeadCardFields(): (arg1: LeadCardFieldsUpdateInput) => Promise<any> {
    const [saveFields] = useMutation<
        LeadCardFieldsUpdateMutation,
        LeadCardFieldsUpdateMutationVariables
    >(LEAD_CARD_FIELDS_UPDATE);

    return (input: LeadCardFieldsUpdateInput) => {
        return saveFields({
            variables: {input},
            update: (proxy, mutationResults) => {
                // Read the data from our cache for this query.
                const cacheResult = proxy.readQuery({
                    query: GET_LEAD_CARD_FIELDS,
                    variables: {stagesetId: input.stagesetId},
                });

                if (cacheResult) {
                    const updatedFields =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.leadCardFieldsUpdate;

                    if (!updatedFields) return;

                    proxy.writeQuery({
                        query: GET_LEAD_CARD_FIELDS,
                        variables: {stagesetId: input.stagesetId},
                        data: {
                            leadCardFields: updatedFields,
                        },
                    });
                }
            },
        });
    };
}
